<template>
  <!-- 分享组件 -->
  <div class="discovery_share_warp">
    <div class="right">
      <div>
        <img src="../../../assets/image/brandico.png" @click="searchFun" />
      </div>
      <div class="tex1">分享</div>
    </div>
    <div class="left">
      <div>
        <img
          src="../../../assets/newIndex/discover_like_default@2x.png"
          alt
          @click="likeFun('y')"
          v-show="!isLike"
        />
      </div>
      <div>
        <img
          src="../../../assets/newIndex/discover_like_select@2x.png"
          alt
          @click="likeFun('n')"
          v-show="isLike"
        />
      </div>
      <div class="tex1">赞{{ likeSum }}</div>
    </div>

    <div class="rigth_btn" v-if="type === 'user'" @click="catbees">
      <img class="img" src="../../../assets/image/bianji2x.png" />
    </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
import utils from "@/utils/common";
export default {
  data() {
    return {
      isLike: false,
      loading: true,
      likeSum: 0,
      shareCount: 0,
      gioObj: {
        entryShape_var: "发现模块",
        entryPage_var: document.title,
        functionName_var: "我想要",
        primarySort_var: "",
        secondSort_var: "",
        thirdSort_var: "",
        fourthSort_var: "",
        brand_var: this.item.branchName || "",
        productName_var: this.item.goodsTitle || "",
      },
    };
  },
  props: {
    isSingle: {
      default: function () {
        return ""
      },
      type: Number
    },
    item: {
      default: function () {
        return {};
      },
      type: Object,
    },
    beesInfo: {
      default: function () {
        return {};
      },
      type: Object,
    },
    type: {
      default: "user",
      type: String,
    },
    likeCount: {
      default: 0,
      type: Number,
    },
    productData: {
      default: function () {
        return {};
      },
      type: Object,
    },
  },
  watch: {
    likeCount: {
      handler(newval, old) {
        this.likeSum = newval;
      },
      immediate: true,
    },
  },
  methods: {
    likeFun(t) {
      if (this.type === "bees") {
        return this.$toast("暂无权限");
      } else {
        this.$minicode.show({
          pageCode: 5011001,
          pageQueryParam: this.$route.query || "",
          isShow: "为了您有更好的体验，请您下载APP 或打开小程序",
        });
        if (this.loading) {
          this.loading = false;
          if(this.item.id){
            http({
              url: "/discover/appuser/userlike/setlikeornot",
              method: "post",
              parmes: {
                discoverId: this.item.id,
                isLike: t,
              },
            }).then((rps) => {
              if (rps.code == 200) {
                this.loading = true;
                if (t == "y") {
                  this.likeSum = this.likeSum + 1;
                } else {
                  this.likeSum = this.likeSum - 1;
                }
                this.isLike = !this.isLike;
              }
            });
          }
          gio("track", "likeSuccess", {
            foundID_var: this.item.id,
            productID_var: this.item.goodsId,
            productName_var: this.item.goodsTitle,
          });
        } else {
          return;
        }
      }
    },
    searchFun() {
      console.log(this.$route.query.atlasId);
      if (this.type === "bees") {
        return this.$toast("暂无权限");
      } else {
        this.$minicode.show({
          pageCode: 5011001,
          pageQueryParam: this.$route.query || "",
          isShow: "为了您有更好的体验，请您下载APP 或打开小程序",
        });
        // if (this.$route.query.atlasId) {
        //   utils.nativeMethod({
        //     tm: 4050101,
        //     tp: {
        //       atlasId: this.$route.query.atlasId,
        //       branchId: this.productData.branchid,
        //       discoverId: this.productData.id
        //     }
        //   });
        //   return;
        // }
        let prmes = {
          easemobname: this.item.easemobName,
          discoverId: this.item.id,
        };
        if (this.item && this.item.goodsId) {
          prmes.goodsId = this.item.goodsId;
        }
        if (this.item.goodsTitle) {
          prmes.goodsName = this.item.goodsTitle;
        }
        utils.shareDiscovery(prmes);
      }
    },
    catbees() {
      let that = this
      if (this.type === "bees") {
        return this.$toast("暂无权限");
      }
      gio('track','userImageProductWant_var',{})
      this.$minicode.show({
        pageCode: 5011001,
        pageQueryParam: this.$route.query || "",
        isShow: "为了您有更好的体验，请您下载APP 或打开小程序",
      });
      let prmes = {
        easemobname: this.item.nimname,
        goodsId: this.item && this.item.goodsId ? this.item.goodsId : 0,
        discoverId: this.item.id,
        goodsName: this.item.goodsTitle || 0,
        key: "beeDiscoverChat",
        nimname: this.item.nimname || "",
      };
      this.$store.dispatch("setUserTrack", {
        trackType: "CONSULT_BEE_BY_DISCOVERY",
        trackMap: { discoveryId: this.item.id, beesId: this.item.beesId || "" },
      });
      // if (this.$route.query.atlasId) {
      //   let params = {
      //     tm: 4050100,
      //     tp: {
      //       imageUrl: this.productData.fileList[0].fileUrl,
      //       goodsName: this.productData.itemName,
      //       goodsSize: this.productData.modelSize
      //         ? this.productData.modelSize
      //         : "",
      //       goodsCostPrice: this.productData.markingPrice,
      //       goodsPrice: this.productData.price,
      //       goodsId: this.productData.goodsId,
      //       atlasId: this.$route.query.atlasId,
      //       discoverId: this.productData.id
      //     }
      //   };
      //   utils.nativeMethod(params);
      //   return false;
      // } else {

      this.http({
        url: "/discover/appbees/atlas/confirmSelected",
        method: "post",
        parmes: {
          branchId:this.item.branchId || "",
          confirmType: "USERWISHED",
          discoverIds: [this.item.id],
          beesId:this.item.beesId
        },
      })
        .then((rps) => {})
        .catch(() => {});

      if (this.item.discoverType == "NORMAL") {
        utils.beeDiscoverChat(prmes);
      } else {
        utils.beeDiscoverChat(prmes);
      }
      // }
      let statusParmes = {
        branchId: that.item.branchId
      }
      if (that.isSingle == 1) {
        statusParmes.isSingle = 'y'
      }
      that.$publicFunc.getJumpSingeOrTeam({
        statusParmes: statusParmes,
        teamParmes: {
          branchId: that.item.branchId
        },
        callback: function (status, teamDetail) {
          prmes.teamChatId = status.isTeamChat && teamDetail.teamChatId ? teamDetail.teamChatId : ""
          utils.beeChatGioReport({
            gio: that.gioObj,
            business: prmes
          });
        }
      })
    },
    getGoodscategory() {
      this.http({
        url: "/order/app/item/findgoodscategory/" + this.item.goodsId,
        method: "GET",
      }).then((rps) => {
        if (rps.code === 200) {
          this.gioObj.primarySort_var = rps.data.categoryLevel1;
          this.gioObj.secondSort_var = rps.data.categoryLevel2;
          this.gioObj.thirdSort_var = rps.data.categoryLevel3;
          this.gioObj.fourthSort_var = rps.data.categoryLevel4;
        }
      });
    },
  },
  created() {
    this.isLike = this.item.like;
    if (this.item && this.item.goodsId) {
      this.getGoodscategory();
    }
  },
};
</script>
<style lang="less" scoped>
.discovery_share_warp {
  border-top: 1px solid #f2f2f2;
  height: 98px;
  background-color: #fff;
  font-size: 28px;
  color: #999;
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  div {
    text-align: center;
    vertical-align: middle;
    span {
      padding: 0 15px;
    }
  }
  .right {
    img {
      width: 44px;
    }
  }
  .left {
    img {
      width: 44px;
    }
  }
  .tex1 {
    font-size: 20px;
    color: #333333;
  }
  .rigth_btn {
    font-size: 24px;
    color: #333;
    margin-top: -39px;
    .img {
      width: 390px;
      height: 120px;
    }
  }
}
</style>